import React, {Component, Fragment} from "react";
import axios from "axios";
import CloseIcon from "../icons/CloseIcon";
import {OPEN_PRODUCT, OPEN_STAFF} from "../util/events";


class StaffPopup extends Component
{

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            staff: null
        }

        this.openStaff = this.openStaff.bind(this);
        this.closeWindow = this.closeWindow.bind(this);
    }

    loadProductData(id)
    {
        this.setState({
            loading: true
        })
        axios.get('cart-api/retrieve-staff?sid=' + id).then((response) => {
            const data = response.data;
            if (data.error === 1) {
                this.setState({
                    loading: false,
                    staff: null
                });
            } else {
                this.setState({
                    loading: false,
                    staff: data
                })
            }
        })
    }

    componentDidMount() {
        this.bindEvents();
    }

    openStaff(e) {
        e.preventDefault();
        if (e.data && e.data.id) {
            this.loadProductData(e.data.id);
        }
    }

    closeWindow(e)
    {
        e.preventDefault();
        this.setState({
            loading: false,
            staff: null
        })
        return false;
    }


    bindEvents()
    {
        const body = document.querySelector('body');
        body.addEventListener(OPEN_STAFF, this.openStaff)
    }

    render() {

        if (!this.state.loading && !this.state.staff) {
            return '';
        }

        return <div className="staff-popup">

            <div className="staff-popup__bg" />
            <div className="staff-popup__inner">
                <div className="container">
                    <div className="container--">

                        {!!this.state.loading && <div className="staff-popup__text">
                            <p>Loading</p>
                        </div>}


                        {!!this.state.staff && <Fragment>
                            <div className="staff-popup__body">
                                <div className="staff-popup__image">
                                    {!!this.state.staff.image && <img src={this.state.staff.image} alt={this.state.staff.name} /> }
                                    <div className="staff-popup__close" onClick={this.closeWindow}>
                                        <CloseIcon />
                                    </div>
                                </div>
                                <div className="staff-popup__text">
                                    <h1>{this.state.staff.name}</h1>
                                    {!!this.state.staff.position && <h4>{this.state.staff.position}</h4>}
                                    <div className="staff-popup__content">
                                        <div dangerouslySetInnerHTML={{__html: this.state.staff.content}} />
                                    </div>
                                    <div className="staff-popup__close-action">
                                        <span className="btn btn--blue--solid btn--blue"
                                           onClick={this.closeWindow}>Close</span>
                                    </div>
                                </div>
                            </div>
                        </Fragment>}
                    </div>
                </div>
            </div>
        </div>
    }

}

export default StaffPopup;
